import gql from 'graphql-tag';

const GET_AGENT_CUSTOMISATION = gql`
  query getAgentCustomisation {
    getAgentCustomisation {
      trayIcon {
        iconId
        name
        description
        enabled
        logoFileName
        menus {
          menuId
          type
          name
          toolTipText
          aboutMessage
          url
          menuOrder
          ticketFormId
          scripts {
            script {
              scriptId
              name
              description
            }
            type
            arguments
          }
        }
      }
      installerIcon {
        iconId
        name
        description
        enabled
        logoFileName
      }
    }
  }
`;

const UPDATE_AGENT_CUSTOMISATION = gql`
  mutation updateAgentCustomisation($input: AgentCustomisationInput!) {
    updateAgentCustomisation(input: $input) {
      trayIcon {
        iconId
        name
        description
        enabled
        logoFileName
        menus {
          menuId
          type
          name
          toolTipText
          aboutMessage
          url
          menuOrder
          ticketFormId
          scripts {
            script {
              scriptId
              name
              description
            }
            type
            arguments
          }
        }
      }
      installerIcon {
        iconId
        name
        description
        enabled
        logoFileName
      }
    }
  }
`;

const GET_TRAY_ICON = gql`
  query {
    getTrayIcon {
      iconId
      name
      description
      enabled
      logoFileName
      menus {
        menuId
        type
        name
        toolTipText
        aboutMessage
        url
        menuOrder
        scripts {
          script {
            scriptId
            name
            description
          }
          type
          arguments
        }
      }
    }
  }
`;

const UPDATE_TRACY_ICON = gql`
  mutation updateTrayIcon($iconId: ID!, $input: TrayIconInput!) {
    updateTrayIcon(iconId: $iconId, input: $input) {
      iconId
      name
      description
      enabled
      logoFileName
      menus {
        menuId
        type
        name
        toolTipText
        aboutMessage
        url
        menuOrder
        scripts {
          script {
            scriptId
            name
            description
          }
          type
          arguments
        }
      }
    }
  }
`;

export {
  UPDATE_TRACY_ICON,
  GET_AGENT_CUSTOMISATION,
  UPDATE_AGENT_CUSTOMISATION,
  GET_TRAY_ICON
};
